<template>
  <div
    class="
      col-lg-12 col-md-12 col-sm-12 col-12
      hoteleria-solicitudes__col hoteleria-solicitudes__div-historial
      d-none
    "
  >
    <div
      class="row hoteleria-s-historial justify-content-center"
      v-if="getAllSolicitudesUsuario"
    >
      <div
        class="
          col-lg-11 col-md-11 col-sm-11 col-11
          hoteleria-s-historial__col
          text-start
          mb-3
        "
      >
        <h4 class="hoteleria-s-historial__h4">Estado de mis solicitudes</h4>
      </div>

      <div
        class="
          col-lg-11 col-md-11 col-sm-11 col-11
          hoteleria-s-historial__col-solicitud
        "
        v-for="solicitud in getAllSolicitudesUsuario"
        :key="solicitud.id_solicitud"
      >
        <div class="row justify-content-center align-items-center">
          <div
            class="
              col-lg-3 col-md-4 col-12
              text-start
              hoteleria-s-historial__col-nombre-solicitud
            "
          >
            <p class="hoteleria-s-historial__nombre-solicitud">
              {{ solicitud.codigo_solicitud }} -
              {{ toDate(solicitud.fecha_creacion) }}
            </p>
          </div>
          <div
            class="col-lg-6 col-md-4 col-6 hoteleria-s-historial__col-estado-s"
          >
            <span class="hoteleria-s-historial__estado-solicitud">
              <font-awesome-icon icon="fa-solid fa-circle" class="me-2 hoteleria-s-historial__icono-estado-a"></font-awesome-icon>
              {{ solicitud.estado.nombre_estado }}
              </span>
          </div>
          <div
            class="
              col-lg-3 col-md-4 col-6
              hoteleria-s-historial__col-ver-detalle
              text-end
            "
          >
            <button
              class="hoteleria-s-historial__btn-ver-detalle"
              data-bs-toggle="modal"
              data-bs-target="#ver-detalle-historial"
              @click="abrirModalHistorial(solicitud)"
            >
              Ver detalle
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import gql from "graphql-tag";

export default {
  name: "HistorialSolicitudes",
  data() {
    return {
      //
    };
  },
  methods: {
    abrirModalHistorial(solicitud) {
      this.$root.$emit("abrir-modal-detalle-historial", solicitud);
    },
    toDate(date) {
      const newDate = new Date(date);

      newDate.setDate(newDate.getDate() + 1);

      return newDate.toLocaleString("es-CL", {
        day: "numeric",
        month: "numeric",
        year: "numeric",
      });
    },
  },
  apollo: {
    getAllSolicitudesUsuario: {
      query: gql`
        {
          getAllSolicitudesUsuario(id_empresa: "1", id_usuario: "1") {
            id_solicitud
            codigo_solicitud
            fecha_creacion
            descripcion_solicitud
            documentos {
              id_documento
              url_documento
            }
            detalles {
              id_detalle
              detalle {
                id_detalle
                nombre_detalle
              }
            }
            estado {
              id_estado
              nombre_estado
              color
            }
          }
        }
      `,
    },
  },
};
</script>